import { RouterSuspense } from '@/common/components/RouterSuspense/RouterSuspense';
import { ROUTES } from '@/common/constants/routes';
import { useEmployeeDetails } from '@/common/contexts/user/UserDetailsContext';
import { useGetEWADetails } from '@/common/integrations/menhir/employee/salary/salary.hooks';
import { areActionsEnabled, isOneOffAvailable } from '@/common/utils/ewa';
import { safeLazy } from '@/common/utils/import';
import { LoadingPlaceholder } from '@/web/components/LoadingPlaceholder/LoadingPlaceholder';
import { Redirect } from 'expo-router';

const { EarnedWageAccessTransfer } = safeLazy(
  () => import('@/web/containers/EarnedWageAccess/EarnedWageAccess')
);

export default function EarnedWageAccessTransferPage() {
  const { details, isInitialLoading } = useGetEWADetails();
  const { employee } = useEmployeeDetails();

  if (isInitialLoading) {
    return <LoadingPlaceholder />;
  }

  if (
    !details ||
    !isOneOffAvailable(details) ||
    !areActionsEnabled(details, employee)
  ) {
    return <Redirect href={ROUTES.NOT_FOUND} />;
  }

  return (
    <RouterSuspense>
      <EarnedWageAccessTransfer />
    </RouterSuspense>
  );
}
